import React from 'react';

function AvatarAI() {
    return (
        <iframe
            style={{
                width: "100%",
                maxWidth: "400px",
                height: "400px",
                border: "solid",
                display: "block",
                margin: "0 auto",
                overflow: "hidden"
            }}
            srcDoc={`
     <!DOCTYPE html>
<html>
<head>
 <style>
 .avatar-container {
    margin: 0 auto;
    width: 100%;
    max-width: 400px;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
 }
 #heygen-streaming-embed {
    z-index: 9999;
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 400px;
    height: 400px;
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.12);
    transition: all linear 0.1s;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
 }
 #heygen-streaming-embed.show {
    opacity: 1;
    visibility: visible;
 }
 #heygen-streaming-container {
    width: 100%;
    height: 100%;
    max-width: 400px;
    max-height: 400px;
    overflow: hidden;
 }
 #heygen-streaming-container iframe {
    width: 100%;
    height: 100%;
    max-width: 400px;
    max-height: 400px;
    border: 0;
    overflow: hidden;
    display: block;
 }
 html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
 }
 </style>
</head>
<body style="overflow: hidden;">
    <div class="avatar-container"></div>
    <script>
        (function(w){
            const h="https://labs.heygen.com",
                  u=h+"/guest/streaming-embed?share=eyJxdWFsaXR5IjoiaGlnaCIsImF2YXRhck5hbWUiOiJmNWViN2MyZGJmMWM0N2IzOTNlYmM0ODllNjZmMmJlMyIsInByZXZpZXdJbWciOiJodHRwczovL2ZpbGVzMi5oZXlnZW4uYWkvYXZhdGFyL3YzL2Y1ZWI3YzJkYmYxYzQ3YjM5M2ViYzQ4OWU2NmYyYmUzL2Z1bGwvMi4yL3ByZXZpZXdfdGFyZ2V0LndlYnAiLCJuZWVkUmVtb3ZlQmFja2dyb3VuZCI6ZmFsc2UsImtub3dsZWRnZUJhc2VJZCI6IjVhOGJiNDUyMjhjOTRhMzVhMjljMDBiMGRmNzU3Y2IxIiwidXNlcm5hbWUiOiJkM2RmZTE2MmZkZDQ0NjVlYjYyOWIxYmY0YmU2NmI3ZiJ9&inIFrame=1";
            const wrapDiv = w.document.createElement("div");
            wrapDiv.id = "heygen-streaming-embed";
            const container = w.document.createElement("div");
            container.id = "heygen-streaming-container";
            const stylesheet = w.document.createElement("style");
            stylesheet.innerHTML = \`
                #heygen-streaming-embed {
                    z-index: 9999;
                    position: relative;
                    margin: 0 auto;
                    width: 100%;
                    max-width: 400px;
                    height: 400px;
                    box-shadow: 0px 8px 24px 0px rgba(0,0,0,0.12);
                    transition: all linear 0.1s;
                    overflow: hidden;
                    opacity: 0;
                    visibility: hidden;
                }
                #heygen-streaming-embed.show {
                    opacity: 1;
                    visibility: visible;
                }
                #heygen-streaming-container {
                    width: 100%;
                    height: 100%;
                    max-width: 400px;
                    max-height: 400px;
                    overflow: hidden;
                }
                #heygen-streaming-container iframe {
                    width: 100%;
                    height: 100%;
                    max-width: 400px;
                    max-height: 400px;
                    border: 0;
                    overflow: hidden;
                    display: block;
                }
            \`;
            const f = w.document.createElement("iframe");
            f.allowFullscreen = false;
            f.title = "Streaming Embed";
            f.role = "dialog";
            f.allow = "microphone";
            f.src = u;
            container.appendChild(f);
            wrapDiv.appendChild(stylesheet);
            wrapDiv.appendChild(container);
            // FIX: append to .avatar-container, not body
            var avatarContainer = w.document.querySelector('.avatar-container');
            if (avatarContainer) {
                avatarContainer.appendChild(wrapDiv);
            }
            let v = false, i = false;
            w.addEventListener("message", function(e){
                if(e.origin===h&&e.data&&e.data.type==="streaming-embed"){
                    if(e.data.action==="init"){
                        i=!0;
                        wrapDiv.classList.toggle("show",i);
                        w.gtag&&gtag("event","avatar_loaded",{event_category:"engagement",event_label:"3govideo_streaming_avatar"})
                    }else if(e.data.action==="show"){
                        v=!0;
                        wrapDiv.classList.toggle("expand",v)
                    }else if(e.data.action==="hide"){
                        v=!1;
                        wrapDiv.classList.toggle("expand",v)
                    }
                }
            });
        })(window);
    </script>
</body>
</html>
            `}
        />
    );
}

export default AvatarAI;